import type { OpenApiSchemaSetupRetailCRMProblemType } from '#shared/api/schema';

export const INTEGRATION_RETAIL_CRM_SETUP_ERRORS_MAPPING = {
    'invalid url': 'Неверный формат ссылки',
    'invalid key': 'Неверный API ключ',
    'invalid site': 'Неверный символьный код магазина',
    'invalid rcct key': 'Неверный Rcct-ключ онлайн-консультанта',
    'connection error': 'Ошибка подключения',
} as const satisfies Record<OpenApiSchemaSetupRetailCRMProblemType, string>;
